const COTAS = {
  data: () => ({}),
  computed: {
    getSession() {
      return this.$store.getters["session/getState"]
    }
  },
  mounted() {},
  methods: {
    GuardarCotas() {
      var object = Object.assign({}, this.MyObject)
      object.anos_pagos = this.cotas
        .map(el => {
          return el.ano
        })
        .join(",")
      object.valores_pagos = this.cotas
        .map(el => {
          return parseFloat(el.valor).toFixed(2)
        })
        .join(",")
      object.id = object[`id_${this.Store}`]
      delete object[`id_${this.Store}`]

      this.$store
        .dispatch(`${this.Store}/update`, object)
        .then(res => {
          if (typeof res == "undefined") return

          if (res) this.$toast.success(this.$success)
          else this.$toast.error(this.$error)

          object[`id_${this.Store}`] = object.id
          this.$eventBus.$emit("RefreshCotas", object)
        })
        .catch(err => {
          this.$toast.error(this.$error)
        })
    }
  }
}

export default COTAS
